export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/bafcb97f65150dd63b7cabadb0e0f790.svg";